module.exports = __webpack_public_path__ + "img/right.bff34f91.png";